export default __webpack_public_path__ + "images/27_1_image.jpg";